<template>
    <div>
        <wrapper-edit
                :wrapper-width="wrapperWidth"
                wTitle="处理售后申请"
                @back="paasPageBack">
            <Row class="refund-wrap" slot="form">
                <Col span="12" class="refund-wrap-left">
                    <div v-if="aftersale.dealStatus === 1">
                        <p v-if="aftersale.warehousingStatus == '1'">买家已退货</p>
                        <p v-else>等待买家退货</p>
                        <mDivider></mDivider>
                    </div>
                    <div v-if="aftersale.dealStatus === '0'">
                        <Form :model="aftersale" :label-width="80" label-position="left">
                            <FormItem label="退款金额:" v-if="aftersale.aftersaleType == 'refund'">
                                <InputNumber v-model="aftersale.refundPrice"></InputNumber>
                            </FormItem>
                            <FormItem label="申诉赔付:" v-if="aftersale.aftersaleType == 'compensate'">
                                <RadioGroup @on-change="changeCompensate">
                                    <Radio label="integral">
                                        <span>退还积分</span>
                                        <Input v-model="aftersale.refundIntegral" search enter-button="积分" :disabled="integralDisabled" />
                                    </Radio>
                                    <Radio label="price">
                                        <span>退款</span>
                                        <Input v-model="aftersale.refundPrice"  search enter-button="元" :disabled="refundDisabled" />
                                    </Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem label="备注:" v-if="aftersale.aftersaleType == 'refund' || aftersale.aftersaleType == 'compensate'">
                                <Input v-model="aftersale.verifyMessage"
                                       type="textarea"
                                       :autosize="{minRows: 2,maxRows: 5}"></Input>
                            </FormItem>
                            <FormItem label="退货说明:" v-if="aftersale.aftersaleType === 'returnGoods' || aftersale.aftersaleType === 'changeGoods'">
                                <Input v-model="aftersale.verifyMessage"
                                       type="textarea"
                                       :autosize="{minRows: 2,maxRows: 5}"></Input>
                            </FormItem>
                            <FormItem label="客服备忘:">
                                <Input v-model="aftersale.customerMemo"
                                       type="textarea"
                                       :autosize="{minRows: 2,maxRows: 5}"></Input>
                            </FormItem>
                            <div class="refund-oper-toolbar" >
                                <Button type="error" @click="saveAuditConfirm('agreeRefund')" v-if="aftersale.aftersaleType == 'refund'">同意退款</Button>
                                <Button type="error" @click="saveAuditConfirm('agreeReturn')" v-if="aftersale.aftersaleType == 'returnGoods'">同意退货</Button>
                                <Button type="error" @click="saveAuditConfirm('agreeExchange')" v-if="aftersale.aftersaleType == 'changeGoods'">同意换货</Button>
                                <Button type="error" @click="saveAuditConfirm('compensate')" v-if="aftersale.aftersaleType == 'compensate'">确定赔付</Button>
                                <Button @click="saveAuditConfirm('reject')">驳回申请</Button>
                            </div>
                        </Form>
                        <mDivider></mDivider>
                    </div>
                    <div v-if="aftersale.dealStatus === '1'">
                        <Form :model="aftersale" :label-width="80" label-position="left">
                            <FormItem label="退款金额:">
                                <InputNumber v-model="aftersale.refundPrice"></InputNumber>
                            </FormItem>
                            <FormItem label="客服备忘:">
                                <Input v-model="aftersale.customerMemo"
                                       type="textarea"
                                       :autosize="{minRows: 2,maxRows: 5}"></Input>
                            </FormItem>
                            <div class="refund-oper-toolbar" >
                                <Button type="error" @click="saveAuditConfirm('createNewOrder')" v-if="aftersale.aftersaleType == 'changeGoods'">已收到货，创建新订单</Button>
                                <Button type="error" @click="saveAuditConfirm('refundMoney')" v-if="aftersale.aftersaleType == 'returnGoods'">已收到货，立即退款</Button>
                                <Button @click="saveAuditConfirm('reject')">驳回申请</Button>
                            </div>
                        </Form>
                        <mDivider></mDivider>
                    </div>

                    <div class="buyer-refund-info">
                        <div class="buyer-avatar">
                            <img :src="avatar?this.avatar:'/image/avatar.png'" width="60" height="60"/>
                        </div>
                        <div class="buyer-info">
                            <p class="lignt_color">{{nickname?nickname:"客户"}}</p>
                            <p>买家（{{nickname}}）于{{aftersale.applyTime}}提交了售后申请</p>
                            <p><strong>售后类型：</strong>
                                <EnumShow
                                        :enum-group-code="'crmdict'"
                                        :enum-code="'aftersaleType'"
                                        :value="aftersale.aftersaleType">
                                </EnumShow>
                            </p>
                            <p><strong>申请数量：</strong>
                                {{aftersale.applyNumber}}
                            </p>
                            <p v-if="aftersale.aftersaleType != 'compensate'"><strong>申请原因：</strong>
                                {{aftersale.applyReason}}
                            </p>
                            <p v-if="aftersale.aftersaleType == 'compensate'"><strong>期望赔偿金额：</strong>
                                {{aftersale.refundPrice}}元
                            </p>
                            <p><strong>描述：</strong>
                                {{aftersale.remark}}
                            </p>
                            <div>
                                <p><strong>退货信息：</strong></p>
                                <span v-if="!aftersale.expressNumber">客户暂未寄回商品</span>
                                <div v-for="(value,key) in express" :key="key" v-else>
                                    <div v-if="key ==='orderExpressDtos'" >
                                        <div v-for="(data,index) in value"  :key="index" >
                                            <div>快递名称：{{data.trackDto.shippingName}}</div>
                                            <div>快递单号：{{data.trackDto.shippingCode}}</div>
                                            <div>快递详情：
                                                <div v-for="(ex,index) in data.trackDto.data" :key="index">
                                                <div>{{ex.time}} {{ex.status}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="aftersale.dealStatus == '201' || aftersale.dealStatus == '202' || aftersale.dealStatus == '203' ">
                                <p>
                                    <strong>审核人：</strong>
                                    {{aftersale.verifyName}}
                                </p>
                                <p>
                                    <strong>审核时间：</strong>
                                    {{aftersale.verifyTime}}
                                </p>
                                <p>
                                    <strong>审核留言：</strong>
                                    {{aftersale.verifyMessage}}
                                </p>
                                <p>
                                    <strong>客服备忘：</strong>
                                    {{aftersale.customerMemo}}
                                </p>
                            </div>
                            <p v-if = "aftersale.img && aftersale.img !== 'null' && typeof(aftersale.img) !== 'undefined'">
                                <strong style="vertical-align: top;">凭证：</strong>
                                <img :src="item"
                                     v-for="(item,key) in aftersale.img.split(',')"
                                     :key="`refundKey_`+key"
                                     width="100"
                                     height="100"/>
                            </p>
                        </div>
                        <div class="buyer-time">
                            <!--<p class="lignt_color">{{aftersale.applyTime}}</p>-->
                        </div>
                    </div>
                    <mDivider></mDivider>
                    <div class="aftersale-process">
                        <h3>售后流程</h3>
                        <!--用户终止-->
                        <div v-if="aftersale.dealStatus == '202'">
                            <Steps :current="current">
                                <Step title="申请售后" :content="aftersale.applyTime"></Step>
                                <Step title="审核,待处理" :content="aftersale.verifyTime" v-if="aftersale.verifyTime != aftersale.completeTime"></Step>
                                <Step title="用户取消申请，售后已完成" :content="aftersale.completeTime"></Step>
                            </Steps>
                        </div>
                        <!--客服终止-->
                        <div v-else-if ="aftersale.dealStatus == '203'">
                            <Steps :current="current">
                                <Step title="申请售后" :content="aftersale.applyTime"></Step>
                                <Step title="审核,待处理" :content="aftersale.verifyTime" v-if="aftersale.verifyTime != aftersale.completeTime"></Step>
                                <Step title="客服取消申请，售后已完成" :content="aftersale.completeTime"></Step>
                            </Steps>
                        </div>
                        <div v-else>
                            <Steps :current="current" v-if="aftersale.aftersaleType == 'returnGoods' || (aftersale.aftersaleType == 'changeGoods'&& order.status != '1')">
                                <Step title="申请售后" :content="aftersale.applyTime"></Step>
                                <Step title="审核,待处理" :content="aftersale.verifyTime"></Step>
                                <Step title="完成" :content="aftersale.completeTime"></Step>
                            </Steps>
                            <Steps :current="current" v-if="aftersale.aftersaleType == 'refund' || aftersale.aftersaleType == 'compensate' ||(aftersale.aftersaleType == 'changeGoods' && order.status == '1')">
                                <Step title="申请售后" :content="aftersale.applyTime"></Step>
                                <Step title="完成" :content="aftersale.completeTime"></Step>
                            </Steps>
                        </div>
                       
                    </div>
                </Col>
                <Col span="12" class="refund-wrap-right">
                    <Widget
                            title="换货信息"
                            icon="iconfont iconwenzhangguanli1"
                            widgeType="simple"
                            titleColor="#2766f6" v-if="aftersale.aftersaleType == 'changeGoods'">
                        <div slot = "toolbar"></div>
                        <div slot="content" class="buyer-refund-info">
                            <div class="refund_product_info">
                                <div class="product_img">
                                    <img :src="aftersale.newImage" width="80" height="80"/>
                                </div>
                                <div class="product_info">
                                    <p class="store_name">
                                        {{aftersale.productName}}
                                    </p>
                                    <p class="lignt_color">
                                        {{aftersale.newProductAttr}}
                                    </p>
                                </div>
                            </div>
                            <div class="order_info">
                                <p><strong>收货人：</strong>{{aftersale.realName}}</p>
                                <p><strong>电话：</strong>{{aftersale.userPhone}}</p>
                                <p><strong>地址：</strong>{{aftersale.province}}{{aftersale.city}}{{aftersale.district}}{{aftersale.userAddress}}</p>
                            </div>
                        </div>
                    </Widget>
                    <Widget
                            title="订单商品"
                            icon="iconfont iconwenzhangguanli1"
                            widgeType="simple"
                            titleColor="#2766f6">
                        <div slot = "toolbar"></div>
                        <div slot="content" class="buyer-refund-info">
                            <div class="refund_product_info">
                                <div class="product_img">
                                    <img :src="aftersale.image" width="80" height="80"/>
                                </div>
                                <div class="product_info">
                                    <p class="store_name">
                                        {{aftersale.productName}}
                                    </p>
                                    <p class="lignt_color">
                                        {{aftersale.productAttr}}
                                    </p>
                                    <p style="color :red;font-size: 20px;">
                                        <EnumShow
                                            :enum-group-code="'crmdict'"
                                            :enum-code="'orderStatus'"
                                            :value="order.status">
                                       </EnumShow>
                                    </p>
                                </div>
                            </div>
                            <mDivider></mDivider>
                            <div class="order_info">
                                <p><strong>买&nbsp;&nbsp;家：</strong>{{nickname}}</p>
                                <p><strong>订单编号：</strong>{{aftersale.orderCode}}</p>
                                <p><strong>成交时间：</strong>{{order.payTime}}</p>
                                <p><strong>应付金额：</strong>￥{{orderProduct.needPaymentAmount}}</p>
                                <p><strong>实付金额：</strong>￥{{orderProduct.truePaymentAmount}}</p>
                                <p><strong>购买数量：</strong>{{orderProduct.purchaseNum}}</p>
                                <p><strong>积分抵扣：</strong>{{orderProduct.integralDeduct}}</p>
                                <p><strong>优惠券抵扣：</strong>{{orderProduct.couponAmount}}</p>
                                <p>
                                    <strong>付款方式：</strong>
                                    <EnumShow
                                            :enum-group-code="'crmdict'"
                                            :enum-code="'payType'"
                                            :value="order.payType">
                                    </EnumShow>
                                </p>
                               
                               
                            </div>

                        </div>
                    </Widget>

                </Col>
            </Row>
        </wrapper-edit>
    </div>
</template>

<script>
    import wrapperEdit from "@/components/paas/wrapper-edit";
    import metaEdit from "@/assets/js/meta-edit.js";
    import {getAftersaleData,saveConfirmRefundMoney,aditSave} from "@api/order.js";
    import mDivider from '@/components/divider/m-divider';
    import EnumShow from "@/components/paas/enum-show";  //如果有枚举，需要引入
    import Widget from '@/components/paas/widget';
    export default {
        name: "auditProcess",
        mixins:[metaEdit],
        components:{wrapperEdit,mDivider,EnumShow,Widget},
        data(){
            return{
                aftersale:{},
                repeatSubmitFlag:"",
                integralDisabled:true,
                refundDisabled:true,
                avatar:"",
                nickname:"",
                order:{},
                express:"",
                orderProduct:{},
                current:1
            }
        },
        created(){
            let id = this.$route.query.id;
            this.returnAftersaleData(id);
        },
        methods:{
            /**
             * create 获取售后数据
             * @param id
             */
            returnAftersaleData(id){
                getAftersaleData(id).then(res=>{
                    this.aftersale = res.data.aftersale;
                    this.express = JSON.parse(this.aftersale.express);
                    this.avatar = res.data.avatar;
                    this.nickname = res.data.nickname;
                    this.order = res.data.order;
                    this.orderProduct = res.data.orderProduct;
                    this.repeatSubmitFlag = res.data.repeatSubmitFlag;
                    if(res.data.aftersale.aftersaleType == "refund" || res.data.aftersale.aftersaleType == "compensate"){
                        if(res.data.aftersale.dealStatus === '0'){
                            this.current = 0;
                        }else{
                            this.current = 1;
                        }
                    }else{
                        if(res.data.aftersale.dealStatus === '0'){
                            this.current = 0;
                        }
                        else if(res.data.aftersale.dealStatus === '1'){
                            this.current = 1;
                        }else{
                            this.current = 2;
                        }
                    }
                })
            },
            changeCompensate(val){
                this.aftersale.compensateType = val;
                if(val == "integral"){
                    this.integralDisabled = false;
                    this.refundDisabled = true;
                }else if(val == "price"){
                    this.refundDisabled = false;
                    this.integralDisabled = true;
                }
            },
            /**
             * 点击关闭逻辑，一般默认跳转list路由页面
             * @param event
             * @param url
             */
            paasPageBack(event){
                this.$router.push({'path': "/eb/order/aftersale/list"});
            },
            /**
             * type:{
             *     reject:驳回申请
             *
             * }
             * @param type
             */
            saveAuditConfirm(type){
                this.aftersale.auditResult = type;
                //如果是质量申诉
                if(type === "compensate"){
                    //退积分
                    if(this.refundDisabled){
                        if(this.aftersale.refundIntegral == ""){
                            this.$Message.error("质量申诉，积分回退不能为空！");
                            return ;
                        }
                    }
                    //退钱
                    if(this.integralDisabled){
                        if(this.aftersale.refundPrice == ""){
                            this.$Message.error("质量申诉，回退金额不能为空！");
                            return ;
                        }
                    }
                }
                aditSave(this.aftersale,this.repeatSubmitFlag).then(res => {
                    if(res.code === 200){
                        this.$router.push({'path': "/eb/order/aftersale/list"});
                    }
                })
            },
            confirmRefundMoney(){

            }
        }
    }
</script>

<style scoped>
    .refund-oper-toolbar button{
        margin:0 10px;
    }
    .title{
        line-height:50px;
    }
    .buyer-info{
        margin-left:20px;
    }
    .buyer-refund-info p,.order_info p{
        line-height:30px;
        text-align:left;
    }
    .buyer-refund-info,.refund_product_info{
        display:flex;
        flex-direction:row;
        flex-wrap: wrap;
        justify-content:space-around;
    }
    .buyer-refund-info{
        justify-content:flex-start;
    }
    .lignt_color{
        color:#cccccc;
    }
    .refund-wrap-left{
        padding-right:20px;
        border-right:1px solid #ccc;
    }
    .refund-wrap-right{
        padding-left:20px;
        border-left:1px solid #ccc;
    }
    .buyer-refund-info .product_info{
        width: 350px;
        margin-left: 10px;
    }
    .aftersale-process{
        width:100%;
    }
    .aftersale-process h3{
        margin-bottom: 10px;
    }
    .aftersale-process >>> .ivu-steps .ivu-steps-head,.aftersale-process >>> .ivu-steps .ivu-steps-title{
        background: #f7f7f7;
    }
</style>